// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"ConfirmModal_buttonWrapper__Izw7T","text":"ConfirmModal_text__t1dWG"};